import http from '@/http'

const PATH = (id) => `/customers/${id}/contacts`

export default {
    /**
     * @param {{customerId: number, params: {}}} data
     * @returns {Promise<void>}
     */
    async listContacts ({customerId, params}) {
        try {
            const response = await http.get(PATH(customerId), {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customerId: number, contactId: number}} data
     * @returns {Promise<void>}
     */
    async showContact ({customerId, contactId}) {
        try {
            const response = await http.get(`${PATH(customerId)}/${contactId}`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
